import {
  LoadingButton_default
} from "./chunk-5UPEKN6R.mjs";

// src/internal/components/create-account-panel/create-account-panel.tsx
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMultientityContext } from "@clara/auth";
import { useCompany } from "@clara/company";
import { useAsyncFn } from "@clara/hooks";
import { Trans, useT } from "@clara/locale";
import { useSnackbar, Image } from "@clara/ui";
import { ZendeskButton } from "@clara/zendesk";
import { jsx, jsxs } from "react/jsx-runtime";
function SidePanel(props) {
  const company = useCompany({ fetchOnMount: false });
  const multientity = useMultientityContext();
  const snackbar = useSnackbar();
  const { t } = useT("common");
  const [{ loading }, create] = useAsyncFn(async () => {
    const response = await company.create.call().then(({ uuid }) => multientity.onChange(uuid, true));
    return response;
  }, []);
  return /* @__PURE__ */ jsxs(Stack, { divider: /* @__PURE__ */ jsx(Divider, {}), spacing: 4, children: [
    /* @__PURE__ */ jsxs(Stack, { spacing: 3, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h2", children: t("accountSwitch.create.headline") }),
      /* @__PURE__ */ jsx(
        Image,
        {
          src: "https://clara-all-assets-prod.s3.amazonaws.com/multientity-modal.svg",
          width: "100%"
        }
      ),
      /* @__PURE__ */ jsxs(Stack, { spacing: 2, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "subtitle2", fontWeight: "600", children: t("accountSwitch.create.tagline") }),
        /* @__PURE__ */ jsxs(Trans, { t, i18nKey: "accountSwitch.create.disclaimer", children: [
          /* @__PURE__ */ jsxs(Typography, { children: [
            "Inicia el proceso solicitud.",
            /* @__PURE__ */ jsx(Typography, { component: "strong", children: "Comparte con nosotros la informaci\xF3n y documentos necesarios." }),
            "Nuestro equipo te contactar\xE1 v\xEDa correo electr\xF3nico con la respuesta."
          ] }),
          /* @__PURE__ */ jsxs(Typography, { children: [
            /* @__PURE__ */ jsx(Typography, { component: "strong", children: "Una vez aprobada la solicitud, te asignaremos una l\xEDnea de cr\xE9dito para la nueva empresa." }),
            " ",
            "Firma tu contrato, asigna al Administrador principal y \xA1listo! empieza a gestionar tus gastos."
          ] }),
          /* @__PURE__ */ jsx(Typography, { component: "strong", children: "Puedes acceder a las cuentas utilizando el usuario que ya tienes creado en Clara." })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { component: Trans, t, i18nKey: "accountSwitch.create.helpline", children: [
        /* @__PURE__ */ jsxs(Typography, { children: [
          /* @__PURE__ */ jsx(Typography, { component: "strong", display: "block", children: "\xBFNecesitas ayuda?" }),
          "Contact\xE1ctanos para darte una soluci\xF3n."
        ] }),
        /* @__PURE__ */ jsx(ZendeskButton, { title: t("metadata.links.helpCenterLabel") })
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      LoadingButton_default,
      {
        loading,
        variant: "contained",
        onClick: () => create().catch(() => {
          snackbar({
            message: t("accountSwitch.create.error"),
            status: "error",
            position: "bottom-left",
            duration: 5e3
          });
        }),
        children: t("accountSwitch.create.submit")
      }
    )
  ] });
}
var CreateAccountPanel = [
  {
    children: [{ element: /* @__PURE__ */ jsx(SidePanel, {}) }]
  }
];
var create_account_panel_default = CreateAccountPanel;

export {
  create_account_panel_default
};
